import { render, staticRenderFns } from "./deleteI-item-button.vue?vue&type=template&id=0e3d08e8"
import script from "./deleteI-item-button.vue?vue&type=script&lang=ts"
export * from "./deleteI-item-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports